<section id="modal" class="{{ modalType }}">
  <!-- Loader -->

  <!-- Modal content -->
  <div class="modal-container">
    <div class="modal-content" [ngStyle]="{ width: width }">
      <img
        src="https://assetslogos.s3-eu-west-1.amazonaws.com/frontendassets/icons/icon__modal__cancel.svg"
        alt="cancel"
        class="cancel-icon"
        (click)="cancel.emit()"
        />
      <h3 class="heading__3 no-margin-b" style="font-size: 20px">
        {{ header }}
      </h3>
      <p class="text__regular">
        {{ subHeader }}
      </p>

      <div class="injected-content">
        <ng-content></ng-content>
      </div>

      <!-- Buttons -->
      @if (buttonText) {
        <div class="btn-group distributed">
          @if (!hideCancelButton) {
            <button
              class="btn btn__secondary mr-2"
              (click)="cancel.emit($event)"
              >
              Cancel
            </button>
          }
          @if (hideBackButton) {
            <button
              class="btn btn__secondary"
              (click)="back.emit($event)"
              >
              Back
            </button>
          }
          @if (!hideSubmitButton) {
            <button
              class="btn btn__primary"
              [disabled]="isDisabled === 'INVALID' ? true : false"
              (click)="submit.emit($event)"
              >
              {{ buttonText }}
            </button>
          }
        </div>
      }
    </div>
  </div>
</section>
